import { LOG, MANAGEMENT, PASS, PERMISSION, careposi } from "@core/configs/menu.config";
import { IMenu, IMenuItem } from "@core/models/interfaces";
import { LIST_MENU } from "@utils/mock-data";
import { orderBy, isEmpty } from 'lodash';

function removeUpToFirstSlash(label: string) {
  const underscoreIndex = label.indexOf('/');
  if (underscoreIndex !== -1) {
    return label.substring(underscoreIndex + 1);
  }
  return label;
}

function convertedMenuItem(label: string): string {
  const str = label.replace('_', '/').replace(/_/g, '-');
  return removeUpToFirstSlash(str);
}

export function getListMenu(menus = []) {
  // let menuItem: IMenu[] = menus.length > 0 ? menus : LocalStorageHelper.getItem(LOCAL_STORAGE_KEY.menu);
  let menuItem: IMenu[] = LIST_MENU;
  const data: any = { careposi: [], auth: [], pass: [], log: [], permission: [], management: [] };
  if (menuItem && menuItem.length > 0) {
    menuItem = orderBy(menuItem, ['id'], ['asc']);
    menuItem.forEach(item => {
      const menu: any = { id: item.id, link: convertedMenuItem(item.code), title: item.name };
      // if (AUTH.includes(item.code)) {
      //   data.auth.push(menu);
      // }
      if (PASS.includes(item.code)) {
        data.pass.push(menu);
      }
      if (LOG.includes(item.code)) {
        const link = item.code.replace('_', '-');
        const menu = { id: item.id, link, title: item.name };
        data.log.push(menu);
      }
      if (PERMISSION.includes(item.code)) {
        data.permission.push(menu);
      }
      if (MANAGEMENT.includes(item.code)) {
        data.management.push(menu);
      }
      if (careposi.includes(item.code)) {
        data.careposi.push(menu);
      }
    });
  }
  return data;
}
export function getMenu(menus = []) {
  const data = getListMenu(menus);
  return checkEmpty(data);
}

function checkEmpty(data: any) {
  const menuItems: IMenuItem[] = [];
  for (const [key, value] of Object.entries(data)) {
    if (!isEmpty(value)) {
      const item = {
        icon: key,
        title: capitalizeFirstLetter(key),
        expanded: true,
        link: key,
        expandIcon: 'up-gray',
        children: value,
      } as IMenuItem;
      menuItems.push(item);
    }
  }
  return menuItems;
}

function capitalizeFirstLetter(text: string): string {
  if (text === 'permission') {
    return '権限・ロール';
  } else if (text === 'management') {
    return '管理';
  } else if (text === 'careposi') {
    return 'Careposi';
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function getAllMenu(menus = []) {
  // let menuItem: IMenu[] = menus.length > 0 ? menus : LocalStorageHelper.getItem(LOCAL_STORAGE_KEY.menu);
  let menuItem: IMenu[] = LIST_MENU;
  const data: string[] = [];
  if (menuItem && menuItem.length > 0) {
    menuItem = orderBy(menuItem, ['id'], ['asc']);
    menuItem.forEach(item => {
      if (LOG.includes(item.code)) {
        const link = item.code.replace('_', '-');
        data.push(`log/${link}`);
      } else {
        const link = item.code.replace('_', '/').replace(/_/g, '-');
        data.push(link);
      }
    });
  }
  return data;
}

export function getFirstURL(menu = []) {
  const menuItems = getAllMenu(menu);
  return menuItems.find(item => item === "careposi/organization-management");
  // return menuItems[0];
}
export function removeAfterSecondSlash(url: string): string {
  const firstSlashIndex = url.indexOf('/');
  const secondSlashIndex = url.indexOf('/', firstSlashIndex + 1);
  if (secondSlashIndex !== -1) {
    return url.substring(0, secondSlashIndex);
  } else if (url.includes('?')) {
    // check query parameters
    const index = url.indexOf('?');
    return url.substring(0, index);
  }
  return url;
}

export function removeLastSegment(url: string): string {
  const segments = url.split('/');
  segments.pop();
  return segments.join('/');
}

export function checkUrlIsAllowed(route: any) {
  const menuItems = getAllMenu();
  let currentURL: string = route['_routerState'].url;
  currentURL = removeAfterSecondSlash(currentURL.replace(/^\//, ''));
  const index = menuItems.findIndex(item => item === currentURL);
  return index > -1;
}

export function checkIs403URL(route: any): boolean {
  let currentURL: string = route['_routerState'].url;
  currentURL = removeAfterSecondSlash(currentURL.replace(/^\//, ''));
  const url = currentURL.replace('/', '_').replaceAll('-', '_');
  const isExistedURL =
    LOG.includes(url) || PASS.includes(url) || PERMISSION.includes(url) || MANAGEMENT.includes(url) || careposi.includes(url);
  return isExistedURL && !checkUrlIsAllowed(route);
}
